import React, { useRef, useEffect } from 'react';
import { Box, Typography, Chip } from '@mui/material';
import ChatMessage from './ChatMessage';
import ChatInput from './ChatInput';

const QUICK_ACTIONS = [
  { label: 'Maak korter',      prompt: 'Maak de vorige tekst korter en bondiger, behoud de kern.' },
  { label: 'Maak creatiever',  prompt: 'Herschrijf de vorige tekst op een creatievere, meer engaging manier.' },
  { label: 'Maak 3 varianten', prompt: 'Maak 3 varianten van de vorige tekst, elk met een andere toon en stijl.' },
  { label: 'Zet om naar script', prompt: 'Zet de vorige tekst om naar een videoscript met scene-beschrijvingen en voice-over tekst.' },
];

export default function ChatPanel({
  messages,
  onSend,
  isStreaming,
  onStop,
  model,
  onModelChange,
  models,
  onOpenPrompts,
  onOpenAgents,
  agentName,
  agentIcon,
  agents,
  clients,
  selectedClientId,
  onClientChange,
  agentToInsert,
  onAgentInserted,
}) {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <Box sx={{
      flex: { xs: 1, md: 2 },
      maxWidth: { md: 420 },
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      bgcolor: '#fff',
      height: { xs: 'auto', md: '100%' },
    }}>
      {/* Header */}
      <Box sx={{
        px: 2,
        py: 1.25,
        borderBottom: '1px solid #f1f4f5',
      }}>
        <Typography sx={{
          fontSize: 13,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          color: '#767c7e',
        }}>
          Chat
        </Typography>
      </Box>

      {/* Messages area */}
      <Box
        ref={scrollRef}
        sx={{
          flex: 1,
          overflowY: 'auto',
          px: 2,
          py: 1.5,
          bgcolor: '#f8f9fa',
        }}
      >
        {messages.filter(msg => msg.role === 'user').map((msg, i) => (
          <ChatMessage
            key={msg.id || `msg-${i}`}
            message={msg}
            compact
          />
        ))}
      </Box>

      {/* Quick Actions */}
      {!isStreaming && messages.length > 0 && (
        <Box sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 0.75,
          px: 2,
          py: 1,
          borderTop: '1px solid #f1f4f5',
        }}>
          {QUICK_ACTIONS.map((action) => (
            <Chip
              key={action.label}
              label={action.label}
              size="small"
              onClick={() => onSend(action.prompt)}
              sx={{
                fontSize: 12,
                fontWeight: 600,
                height: 28,
                bgcolor: '#f1f4f5',
                color: '#556071',
                cursor: 'pointer',
                transition: 'all 0.15s',
                '&:hover': {
                  bgcolor: '#d5e3fd',
                  color: '#526075',
                },
              }}
            />
          ))}
        </Box>
      )}

      {/* Chat Input */}
      <ChatInput
        onSend={onSend}
        isStreaming={isStreaming}
        onStop={onStop}
        model={model}
        onModelChange={onModelChange}
        models={models}
        onOpenPrompts={onOpenPrompts}
        onOpenAgents={onOpenAgents}
        agents={agents}
        clients={clients}
        selectedClientId={selectedClientId}
        onClientChange={onClientChange}
        agentToInsert={agentToInsert}
        onAgentInserted={onAgentInserted}
        compact
      />
    </Box>
  );
}
